export const DASHBOARD_TITLES = {
  addressLookup: 'Address Lookup',
  adminArea: 'Admin Area',
  audit: 'Audit',
  calculator: 'Calculator',
  chatter: 'Chatter',
  companyNavigator: 'Company Navigator',
  crm: 'CRM',
  customers: 'Customers',
  dashboard: 'Dashboard',
  extensions: 'Extensions',
  extremeCautionList: 'Extreme Caution List',
  faqGuideAndVideos: 'FAQ Guide and Videos',
  fca: 'FCA',
  fileExplorer: 'File Explorer',
  fileStorage: 'File Storage',
  graphqlCrm: 'Graphql CRM',
  kanban: 'Kanban',
  legacyDealsViewer: 'Legacy Deals Viewer',
  lenders: 'Lenders',
  marketingCampaigns: 'Marketing Campaigns',
  messageHub: 'Message Hub',
  portal: 'Portal',
  settings: 'Settings',
  support: 'Support',
  users: 'Users',
  vrm: 'VRM',
  bipsNoticeboard: 'Bips Noticeboard'
} as const;

const DASHBOARD_ROUTE_TITLE_MATCHERS: Array<{
  title: string;
  matches: (pathname: string) => boolean;
}> = [
  { title: DASHBOARD_TITLES.dashboard, matches: (pathname) => pathname.startsWith('/dashboard') },
  { title: DASHBOARD_TITLES.customers, matches: (pathname) => pathname.startsWith('/customers') },
  { title: DASHBOARD_TITLES.companyNavigator, matches: (pathname) => pathname.startsWith('/company-navigator') },
  { title: DASHBOARD_TITLES.marketingCampaigns, matches: (pathname) => pathname.startsWith('/marketing') },
  { title: DASHBOARD_TITLES.fileStorage, matches: (pathname) => pathname.startsWith('/storage') },
  { title: DASHBOARD_TITLES.fileExplorer, matches: (pathname) => pathname.startsWith('/file-explorer') },
  { title: DASHBOARD_TITLES.support, matches: (pathname) => pathname.startsWith('/support') },
  { title: DASHBOARD_TITLES.vrm, matches: (pathname) => pathname.startsWith('/vrm') },
  { title: DASHBOARD_TITLES.calculator, matches: (pathname) => pathname.startsWith('/calculator') },
  { title: DASHBOARD_TITLES.legacyDealsViewer, matches: (pathname) => pathname.startsWith('/legacy-deals-viewer') },
  { title: DASHBOARD_TITLES.messageHub, matches: (pathname) => pathname.startsWith('/message-hub') },
  { title: DASHBOARD_TITLES.adminArea, matches: (pathname) => pathname.startsWith('/admin') },
  { title: DASHBOARD_TITLES.addressLookup, matches: (pathname) => pathname.startsWith('/address/lookup') },
  { title: DASHBOARD_TITLES.audit, matches: (pathname) => pathname.startsWith('/audit') },
  { title: DASHBOARD_TITLES.chatter, matches: (pathname) => pathname.startsWith('/chatter') },
  { title: DASHBOARD_TITLES.graphqlCrm, matches: (pathname) => pathname.startsWith('/graphql-crm') },
  { title: DASHBOARD_TITLES.kanban, matches: (pathname) => pathname.startsWith('/kanban') },
  { title: DASHBOARD_TITLES.faqGuideAndVideos, matches: (pathname) => pathname.startsWith('/faq') },
  { title: DASHBOARD_TITLES.extremeCautionList, matches: (pathname) => pathname.startsWith('/extreme-caution') },
  { title: DASHBOARD_TITLES.fca, matches: (pathname) => pathname.startsWith('/fca') },
  { title: DASHBOARD_TITLES.lenders, matches: (pathname) => pathname.startsWith('/lenders') },
  { title: DASHBOARD_TITLES.settings, matches: (pathname) => pathname.startsWith('/settings') },
  { title: DASHBOARD_TITLES.portal, matches: (pathname) => pathname.startsWith('/portal') },
  { title: DASHBOARD_TITLES.extensions, matches: (pathname) => pathname.startsWith('/extensions') },
  { title: DASHBOARD_TITLES.crm, matches: (pathname) => pathname.startsWith('/test-flight') },
  { title: DASHBOARD_TITLES.crm, matches: (pathname) => pathname.startsWith('/bips-weekly') },
  { title: DASHBOARD_TITLES.bipsNoticeboard, matches: (pathname) => pathname.startsWith('/noticeboard-Builder') },
  { title: DASHBOARD_TITLES.users, matches: (pathname) => pathname.startsWith('/users') }
];

export const getDashboardRouteTitle = (
  pathname: string,
  processesName?: string
): string | undefined => {
  if (pathname.startsWith('/deals')) {
    return processesName ? `${processesName}s` : 'Deals';
  }

  const matchedTitle = DASHBOARD_ROUTE_TITLE_MATCHERS.find(({ matches }) =>
    matches(pathname)
  );

  if (matchedTitle) {
    return matchedTitle.title;
  }

  const fallbackSegment = pathname.split('/').filter(Boolean)[0];

  if (!fallbackSegment) return undefined;

  return fallbackSegment
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
